function Loader() {
  return {
     restrict: 'EA',
    scope: {
      loader: '=loader'
    },
    template: '<div class="lds-css ng-scope" >'+
    '<div class="lds-spinner" ng-class="loader"><div></div><div></div><div></div><div></'+
    'div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div>'+
    '</div></div>'
  };
}

export default {
  name: 'loadingSpinner',
  fn: Loader
};

